import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';

/**
 * Campo de busca.
 *  - aoEnviar(valor): chamado ao apertar Enter / clicar em "Buscar"
 *  - aoDigitar(valor): opcional; se informado, busca enquanto digita
 */
function BarraBusca({ valor = '', aoEnviar, aoDigitar, placeholder, rotulo = 'Buscar', botao = true, autoFoco = false }) {
    const [texto, setTexto] = useState(valor);

    // mantém o campo em sincronia quando a URL muda (ex.: botão voltar)
    useEffect(() => { setTexto(valor); }, [valor]);

    const mudar = (v) => {
        setTexto(v);
        if (aoDigitar) aoDigitar(v);
    };

    return (
        <form
            className="busca"
            role="search"
            onSubmit={(e) => {
                e.preventDefault();
                if (aoEnviar) aoEnviar(texto.trim());
            }}
        >
            <label className="busca__label" htmlFor="campo-busca">{rotulo}</label>
            <div className="busca__campo">
                <FontAwesomeIcon icon={faMagnifyingGlass} className="busca__icone" />
                <input
                    id="campo-busca"
                    type="search"
                    className="busca__input"
                    value={texto}
                    placeholder={placeholder}
                    autoComplete="off"
                    autoFocus={autoFoco}
                    onChange={(e) => mudar(e.target.value)}
                />
                {texto && (
                    <button type="button" className="busca__limpar" aria-label="Limpar busca" onClick={() => mudar('')}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                )}
            </div>
            {botao && <button type="submit" className="busca__botao">Buscar</button>}
        </form>
    );
}

export default BarraBusca;
